import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { safeNext, type SignInTarget } from "./safeNext";

/**
 * xmg-sec-mfa: where the two second-factor screens send the user once the code is accepted - the `next` OAuth
 * callback (a real navigation) or the SPA route the sign-in started from, both carried in `location.state` by
 * `LoginScreen` / `RequireSession`.
 */
export function useFinishSignIn(): { target: SignInTarget; finish: () => void } {
  const location = useLocation();
  const navigate = useNavigate();
  const state = (location.state ?? null) as { from?: string; next?: string | null } | null;
  const from = state?.from ?? "/";
  const next = safeNext(state?.next ?? null);
  const finish = useCallback(() => {
    if (next !== null) {
      window.location.assign(next);
    } else {
      navigate(from, { replace: true });
    }
  }, [from, next, navigate]);
  return { target: { from, next }, finish };
}
